import React from "react";
import { useDesigner } from "./useDesigner";
import { ElementContext, useElementContext } from "./useElementContext";
import { useContentState } from "./useContentState";
import { ContentItems } from "./ContentItems";
import { SignatureBlock } from "../core/pdf/types";
import { ElementTag } from "./ElementTag";

export function SignatureBlockEditor(props: {
	sig: SignatureBlock,
}) {
	const designer = useDesigner();

	const elementContext = useElementContext(props.sig);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {

	}, []));

	let w = "80mm";
	let h = "25mm";
	let gap = "7mm";

	if (props.sig.sigHeight) {
		h = props.sig.sigHeight + "px";
	}

	const contentStyle = {
		marginTop: gap,
	};

	return (
		<ElementContext.Provider value={elementContext}>
			<div
				className={"signature-block-editor content-element flex align-start " + state.classes}
				data-key={props.sig.id}
				id={state.elementID}
				tabIndex={0}
			>
				<ElementTag />

				<div className="flex vert align-start" style={{width: w}}>
					<div style={{height: h, borderBottom: "solid black 1px"}} className="width-100pc"></div>

					<div style={contentStyle} className="width-100pc">
						<ContentItems
							content={props.sig.content}
						/>
					</div>
				</div>
			</div>
		</ElementContext.Provider>
	)
}